import { render, staticRenderFns } from "./FormatReferenceDirectoryFilter.vue?vue&type=template&id=54c1e9de&scoped=true&"
import script from "./FormatReferenceDirectoryFilter.vue?vue&type=script&lang=ts&"
export * from "./FormatReferenceDirectoryFilter.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferenceDirectoryFilter.vue?vue&type=style&index=0&id=54c1e9de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1e9de",
  null
  
)

export default component.exports